module.exports = __webpack_public_path__ + "static/media/brand.7cd27597.png";


//////////////////
// WEBPACK FOOTER
// ./public/img/brand.png
// module id = 421
// module chunks = 0